module.exports = __webpack_public_path__ + "assets/img/driver-btn-1427e313.png";